// extracted by mini-css-extract-plugin
export var copyableField = "_n6-4";
export var customerBadge = "_n6-0";
export var customerInfoTitle = "_n6-2";
export var details = "_n6-1";
export var dropdownContainer = "_n6-5";
export var dropdownImage = "_n6-6";
export var editAssigneeForm = "_n6-a";
export var editButton = "_n6-3";
export var email = "_n6-7";
export var hidden = "_n6-d";
export var input = "_n6-8";
export var saveButton = "_n6-b";
export var shopifyIcon = "_n6-c";
export var suggestionBadge = "_n6-e";
export var suggestionText = "_n6-f";
export var username = "_n6-9";